export { View as Step2 } from './view'
